import { createRoot } from 'react-dom/client'

// Import DevExtreme Material Blue Light theme CSS (pre-built)
import 'devextreme/dist/css/dx.material.blue.light.css'
import './index.css'

// Initialize DevExtreme license and Slovenian localization before importing components
import './lib/devextreme-setup'

import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <App />,
)
